<script lang="ts">
  export let checked: boolean = true;
  export let description: string = "";
  export let labelStyle: string = "";
</script>

<label class="block relative cursor-pointer">
  <input
    class="absolute w-0 h-0 opacity-0"
    bind:checked
    type="checkbox"
    {...$$restProps}
  />

  <div class="flex flex-row items-center gap-2">
    <div class="checkmark" class:checked>
      <svg
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.29885 6.13563L1.06622 3.83614L0.321289 4.60226L3.29885 7.669L9.67873 1.09806L8.93488 0.330811L3.29885 6.13563Z"
          fill="white"
        />
        <path
          d="M3.29885 8L0 4.60236L1.06513 3.50533L3.29776 5.80482L8.93487 0L10 1.09703L3.29885 8ZM0.642562 4.60236L3.29885 7.33819L9.35853 1.09703L8.93487 0.660684L3.29885 6.46663L1.06622 4.16601L0.642562 4.60236Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="text-dark-200 font-medium" style={labelStyle}>{description}</div>
  </div>
</label>

<style lang="postcss">
  label {
    max-width: fit-content;
  }

  .checkmark {
    @apply flex flex-row items-center justify-center;
    @apply w-5 h-5 rounded border-2 border-solid border-primary-datadocs-blue box-border;
  }

  .checkmark.checked {
    @apply bg-primary-datadocs-blue;
  }

  .checkmark svg {
    @apply opacity-0;
  }

  .checkmark.checked svg {
    @apply opacity-100;
  }
</style>
